module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/metadata/metadata.component.css
// module id = ./src/app/metadata/metadata.component.css
// module chunks = main